export default __webpack_public_path__ + "static/media/amDotNetv1-3.9a59f1e4.jpg";